export default {
  hero: {
    simple: "A reverse mortgage can help you",
    rate: "live a more comfortable life",
    subtitle: "A reverse mortgage can help you",
    footnote:
      "Through an equity release (commonly known as reverse  mortgage), you can turn  a portion of your home into a source of cash",
    cta_new: "APPLY",
    cta_renewal: "How much can I get?"
  }
}



// WEBPACK FOOTER //
// ./src/i18n/translations/en/hero.js